import React from "react";
const AnimateSpin = () => {
  return (
    <div className="flex justify-center w-full items-center h-full">
      <div className="animate-spin rounded-full border-t-2 border-b-2 border-primary w-10 h-10 lg:h-16 lg:w-16"></div>
    </div>
  );
};
export default AnimateSpin;
